import { OpenPanelFilledLeft, OpenPanelLeft } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { useDataTableContext } from '../context';

// ─────────────────────────────────────
// Component
// ─────────────────────────────────────

/**
 * Toggle button for showing/hiding the filter panel sidebar.
 * Displays active filter count when filters are applied.
 * @return {JSX.Element} The filter toggle button element
 */
export function FilterToggle() {
  const { activeFilterCount, isFilterPanelOpen, setIsFilterPanelOpen } =
    useDataTableContext();

  return (
    <Button
      kind="ghost"
      size="lg"
      onClick={() => setIsFilterPanelOpen(!isFilterPanelOpen)}
      renderIcon={isFilterPanelOpen ? OpenPanelFilledLeft : OpenPanelLeft}
      data-testid="table-filter-button"
    >
      {activeFilterCount === 0
        ? isFilterPanelOpen
          ? 'Hide Filters'
          : 'Show Filters'
        : activeFilterCount === 1
          ? '1 Filter Applied'
          : `${activeFilterCount} Filters Applied`}
    </Button>
  );
}
